function sineOut(t) {
  return Math.sin(t * Math.PI/2)
}

module.exports = sineOut